import styled from 'styled-components';
import {boxCss} from '../../styles/box.styled';
import {alignNormalCss} from '../../styles/align.styled';

export const ImageStyled = styled.div`
  ${alignNormalCss}
  img {
    //max-width: 100%;
    width: 100%;
    ${boxCss}
  }
`;

